<template>
  <d2-container>
    <!-- 修改标题 -->
    <top-line :message="pageTitle" :iconclass="'fa fa-history'"></top-line>
    <el-row class="pagebody">
      <!-- 搜索过滤栏 -->
      <el-card shadow="never" class="filter-bar">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="100px">
          <el-row>
            <!-- 可保留的搜索项 -->
            <el-col :span="6">
              <el-form-item label="操作账号" prop="account">
                <el-input v-model="searchForm.account" placeholder="请输入账号" style="width: 175px" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用户名称" prop="username">
                <el-input v-model="searchForm.username" placeholder="请输入姓名" style="width: 175px" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="请求IP" prop="client_ip">
                <el-input v-model="searchForm.client_ip" placeholder="请输入IP" style="width: 175px" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6" style="text-align: right; padding-top: 10px;">
              <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
              <el-button type="info" icon="el-icon-refresh-left" size="small" @click="handleReset" style="margin-left: 8px">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 表格：替换为操作日志字段 -->
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :max-height="600"
      >
        <el-table-column prop="id" label="日志ID" width="80" />
        <el-table-column prop="account" label="操作账号" min-width="140" show-overflow-tooltip />
        <el-table-column prop="username" label="用户名称" min-width="120" show-overflow-tooltip />
        <!-- <el-table-column prop="user_id" label="用户ID" min-width="140" show-overflow-tooltip /> -->

        <!-- 请求方式 -->
        <el-table-column prop="method" label="请求方式" width="100">
          <template v-slot="scope">
            <el-tag :type="getMethodType(scope.row.method)">
              {{ scope.row.method }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 请求路径 -->
        <el-table-column prop="path" label="请求地址" min-width="200" show-overflow-tooltip />

        <!-- 状态码 -->
        <el-table-column prop="status" label="状态码" width="100">
          <template v-slot="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 响应时间 -->
        <el-table-column prop="latency" label="响应时间(ms)" width="130">
          <template #default="{ row }">
            {{ row.latency }}ms
          </template>
        </el-table-column>

        <!-- 客户端IP -->
        <el-table-column prop="client_ip" label="客户端IP" min-width="130" />

        <!-- 创建时间 -->
        <el-table-column prop="created_at" label="操作时间" width="170">
          <template #default="{ row }">
            {{ formatDateTime(row.created_at) }}
          </template>
        </el-table-column>

        <!-- 错误信息 -->
        <el-table-column prop="err" label="错误信息" min-width="180" show-overflow-tooltip>
          <template #default="{ row }">
            <span v-if="row.err" style="color: #F56C6C">{{ row.err }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row type="flex" justify="left" style="margin-top: 15px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.pageSizeList"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";
import { MessageBox } from 'element-ui';

export default {
  name: "operation-log",
  components: {
    topLine,
  },
  mounted() {
    this.loadParams();
  },
  data() {
    return {
      pageTitle: "操作日志", // 修改标题
      tableDataApi: '/api-30216/api/logs/operation', // 修改接口地址（请根据实际后端接口调整）
      searchForm: {
        account: '',
        username: '',
        client_ip: '', // 替换 ipaddr -> client_ip
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
      },
      tableData: []
    };
  },
  methods: {
    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1).toString().padStart(2, '0') + '-';
      const D = date.getDate().toString().padStart(2, '0') + ' ';
      const h = date.getHours().toString().padStart(2, '0') + ':';
      const m = date.getMinutes().toString().padStart(2, '0') + ':';
      const s = date.getSeconds().toString().padStart(2, '0');
      return Y + M + D + h + m + s;
    },

    // 根据 method 显示不同颜色
    getMethodType(method) {
      if (!method) return '';
      switch (method.toUpperCase()) {
        case 'GET': return 'success';
        case 'POST': return 'primary';
        case 'PUT': return 'warning';
        case 'DELETE': return 'danger';
        default: return 'info';
      }
    },

    // 根据 status 显示不同颜色
    getStatusType(status) {
      if (status >= 200 && status < 300) return 'success';
      if (status >= 400 && status < 500) return 'warning';
      if (status >= 500) return 'danger';
      return 'info';
    },

    loadParams() {
      const query = this.$route.query;
      if (query.page) this.pagination.page = parseInt(query.page, 10);
      if (query.pageSize) this.pagination.pageSize = parseInt(query.pageSize, 10);
      this.getTableData();
    },

    handleReset() {
      this.searchForm = {
        account: '',
        username: '',
        client_ip: '',
        page: 1,
        pageSize: this.pagination.pageSize
      };
      this.pagination.page = 1;
      this.getTableData();
    },

    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },

    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },

    getTableData() {
      const params = { ...this.searchForm };
      params.page = this.pagination.page;
      params.pageSize = this.pagination.pageSize;

      this.$axios.get(this.tableDataApi, { params })
        .then(res => {
          this.tableData = res.data || [];
          this.pagination.total = res.total || 0;
          this.loading = false;
        })
        .catch(err => {
          console.error('获取操作日志失败', err);
          this.$message.error('数据加载失败');
        });
    }
  }
};
</script>

<style scoped lang="scss">
.pagebody {
  margin: 20px;
}
.filter-bar {
  margin-bottom: 15px;
}
</style>